module.exports = __webpack_public_path__ + "img/opening-act-1.8ee0ca6a.jpg";